// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"337":"1a86d48a3abb17fb","809":"71099ce9e10a480c"}[chunkId] + ".js";
};